<template>
  <div
    class="sf-inbox-messages-item"
    :class="{ active: isActive }"
    @click="$emit('click', id)"
  >
    <div class="sf-commcard-message sf-pad-v-1">
      <div class="sf-pad-l-2">
        <span v-tooltip="iconTooltip" class="sf-inline-block">
          <span :class="iconClass" @click="handleIconClick" />
        </span>
      </div>
      <div class="sf-commcard-message-content">
        <div class="sf-commcard-message-content-post sf-commcard-post">
          <div
            v-if="contextSubject"
            class="sf-uppercase sf-below-1"
            :class="hideSessionClass"
          >
            {{ contextSubject }}
          </div>
          <div class="sf-commcard-post-author">
            <div class="sf-commcard-post-name" :class="hideSessionClass">
              {{ submitters[0].name }}
            </div>
            <div v-tooltip.timestamp="updatedAt" class="sf-commcard-post-date">
              {{ I18n.t('communication.cards.edited') }}
              {{ updatedAtFormatted }}
            </div>
          </div>
          <div
            v-dompurify-html="text"
            class="sf-commcard-post-text"
            :class="hideSessionClass"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import trackEvent from '@app/utils/track_event'
import communicationDate from '@app/utils/communication-date'
import useRedactSessionRecording from '@app/shared/vue/composables/use-hide-session-recording'

export default {
  props: [
    'id',
    'read',
    'updatedAt',
    'text',
    'submitters',
    'isActive',
    'handleClick',
    'contextSubject',
  ],
  emits: ['click', 'markUnread'],

  setup() {
    const hideSessionClass = useRedactSessionRecording()
    return {
      hideSessionClass,
    }
  },

  computed: {
    iconClass() {
      return {
        icon: true,
        'icon-circle': true,
        'sf-c-danger': !this.read,
        'sf-c-snow-dark': Boolean(this.read),
        'sf-font-m': true,
      }
    },
    iconTooltip() {
      return this.read
        ? this.I18n.t('components.notification.single.toggle_read_tooltip.true')
        : ''
    },
    updatedAtFormatted() {
      return communicationDate(this.updatedAt)
    },
  },
  methods: {
    handleIconClick(evt) {
      if (this.read) {
        evt.stopPropagation()
        this.$emit('markUnread', this.id)
        trackEvent('inbox', 'click', 'mark-as-unread')
      }
    },
  },
}
</script>

<style scoped>
.sf-commcard-post-text {
  max-height: 54px;
  overflow: hidden;
}
</style>
